import { render, staticRenderFns } from "./productPharmacy.vue?vue&type=template&id=3d909dba&scoped=true"
import script from "./productPharmacy.vue?vue&type=script&lang=js"
export * from "./productPharmacy.vue?vue&type=script&lang=js"
import style0 from "./productPharmacy.vue?vue&type=style&index=0&id=3d909dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d909dba",
  null
  
)

export default component.exports